import { createApiClient } from '@mustauto/utils/api-client';
import { getFirebaseAuth } from './firebase';

export const api = createApiClient({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  getToken: async (forceRefresh?: boolean) => {
    const auth = getFirebaseAuth();
    // Boot race: requests podem disparar antes do Firebase restaurar a sessão.
    await auth.authStateReady();
    const user = auth.currentUser;
    return user ? user.getIdToken(forceRefresh) : null;
  },
  // Sessão expirada/inválida (401): desloga e manda pro login.
  // 403 fica para as páginas tratarem (acesso negado, não falta de sessão).
  onUnauthorized: async () => {
    try {
      await getFirebaseAuth().signOut();
    } catch {
      // o redirect precisa acontecer de qualquer forma
    }
    window.location.assign('/login');
  },
});
